<script lang="ts">
    import type { ProductLink } from './ProductLink.ts';

    interface Props {
        id: string;
        link: ProductLink;
        onClick?: (event: Event) => void;
        linkType?: 'image' | 'tile';
    }

    const { id, link, onClick, linkType = 'tile' }: Props = $props();
</script>

{#if link.index}
    <oc-link-v2
        {id}
        base64-href={btoa(link.detailPageLink)}
        data-primary-action
        data-link-type={linkType}
        data-qa="find_tile__productLink"
    >
        <a href={link.href} aria-label={link.title} data-link-type={linkType} onclick={onClick}></a>
    </oc-link-v2>
{:else}
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <oc-link-v2
        {id}
        base64-href={btoa(link.detailPageLink)}
        data-primary-action
        oc-aria-label={link.title}
        title={link.title}
        data-link-type={linkType}
        data-qa="find_tile__productLink"
        onclick={onClick}
    ></oc-link-v2>
{/if}
